<div>


  <div class="nav-under container-fluid header-borders border-bottom py-2">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb bg-white page-title">
        <li class="breadcrumb-item">App Content</li>
        <li class="breadcrumb-item active" aria-current="page"><a routerLink="/financial-lit-topics">Financial Literacy</a></li>
        <li class="breadcrumb-item" aria-current="page">{{literacyTopic}}</li>
      </ol>
    </nav>
  </div>

  <div class="tabs border-bottom">
    <a class="tab-link active" (click)="openCity($event, 'about')">About</a>
    <a class="tab-link" (click)="openCity($event, 'financial-lit')">Financial Literacy</a>
  </div>

  <div id="about" class="tabcontent container-fluid">
    <div class="py-2">
      <h3 class="page-subtitle">About {{literacyTopic}}</h3>
    </div>

    <form
      (ngSubmit)="updateLiteracyTopic(updateLiteracyTopicForm.value)"
      #updateLiteracyTopicForm="ngForm"
      class="py-2"
    >
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="name">Topic</label>
            <input
              type="text"
              class="form-control change-input-field"
              placeholder="Literacy topic"
              name="topic"
              ngModel
              #topic="ngModel"
              [(ngModel)]="literacyTopic"
              minlength="3"
              readonly
            />
          </div>

          <div class="form-group">
            <label for="name">Description</label>
            <quill-editor
              name="description"
              #description="ngModel"
              [(ngModel)]="topicDescription"
              [modules]="quillConfig"
              [styles]="editorStyle"
            >
            </quill-editor>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <div class="row">
              <div class="col-md-6">
                <img src='{{ "https://storage.googleapis.com/ezyagric-media" + topicImage }}' class="img-fluid" alt="{{topicImage}}" />
              </div>
              <div class="col-md-6">
                <label for="photo">Upload New Image</label>
                <input
                  type="file"
                  value="CHOOSE FILE"
                  name="photo"
                  class="form-control change-files file-input"
                  (change)="changeImage($event)"
                  accept="image/png, image/jpeg, image/jpg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-align-right">
        <button type="submit" class="submit-input-btn ui-btn" >
          <span *ngIf="loading" class="spinner-border spinner-border-md
            text-white change-loading" role="status"></span>
          <span *ngIf="loading" class="mx-2">Loading...</span>
          <span *ngIf="!loading">
            <i class="fa fa-check text-success "></i> Save changes
          </span>
        </button>
      </div>
    </form>
  </div>

  <div id="financial-lit" class="tabcontent container-fluid" style="display: none;">
    <div class="mt-4">
      <div class=" row mb-2" *ngIf="!isLoadingContent">
        <div class="col-md-auto col-12">
          <div class="h-100 d-flex align-items-center ">
            <h3 class="page-subtitle">Financial Literacy</h3>
            <button
              class="btn btn-primary btn-sm ml-5"
              data-toggle="modal"
              data-target="#addLiteracyContentModal"
            >
              Add Content
            </button>
          </div>
        </div>
        <div class="col"></div>
        <div class="col-12 col-md-auto">
          <input
            type="text"
            placeholder="Search"
            name="searchContent"
            (keyup)="filterLiteracyContent($event)"
            class="px-2 py-1"
          >
        </div>
      </div>
      <div class="spinner d-block w-100 py-5 text-center" *ngIf="isLoadingContent">
        <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
      </div>
      <div *ngIf="!isLoadingContent">
        <div *ngIf="literacyData?.length===0" style="text-align: center;">
          No financial literacy content added yet...
        </div>
        <div *ngIf="literacyData?.length>0">
          <table class="table table-bordered table-primary">
            <thead>
              <tr class="text-uppercase">
                <th>#</th>
                <th scope="col">Heading</th>
                <th scope="col">Image</th>
                <th scope="col">Status</th>
                <th scope="col">Sub heading</th>
                <th scope="col">Description</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of literacyDataFilter | paginate: { itemsPerPage: count, currentPage: page };
              let i = index">
                <td>{{ (page - 1) * count + i + 1 }}</td>
                <td>{{row.heading}}</td>
                <td>
                  <div class="mult_images">
                    <div *ngFor="let photo of row.photo_urls">
                      <div class="img-holder mb-1" *ngIf="photo.image_url">
                        <img src='{{ "https://storage.googleapis.com/ezyagric-media" + photo.image_url }}' alt="{{row.crop}}"
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td
                  [className]="row.status"
                >
                  <span class="dot mr-2"></span>
                  {{row.status | titlecase}}
                </td>
                <td>{{row.sub_heading}}</td>
                <td [innerHTML]="row.description | truncateText:50"></td>
                <td>
                  <div class="dropdown">
                    <button class="btn btn-outline-info dropdown-toggle" type="button" id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      ACTION
                    </button>
                    <div class="dropdown-menu dropdown-menu-right options" aria-labelledby="dropdownMenuButton">
                      <button
                        class="dropdown-item suspend"
                        data-toggle="modal"
                        data-target="#editLiteracyContentModal"
                        (click)="setSingleContentViewData(row)"
                      >
                        View details
                      </button>
                      <button
                        *ngIf="checkPublishStatus('inactive',row)"
                        class="dropdown-item suspend text-success"
                        data-toggle="modal"
                        data-target="#publishContent"
                        (click)="setSingleContentViewData(row)"
                      >
                        Publish
                      </button>
                      <button
                        *ngIf="checkPublishStatus('active',row)"
                        class="dropdown-item suspend text-danger"
                        data-toggle="modal"
                        data-target="#publishContent"
                        (click)="setSingleContentViewData(row)"
                      >
                        Unpublish
                      </button>
                      <button
                        class="dropdown-item suspend text-danger"
                        data-toggle="modal"
                        data-target="#deleteLiteracyModal"
                        (click)="setSingleContentViewData(row)"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="!isLoadingContent">
            <nav>
              <pagination-controls (pageChange)="page = $event"></pagination-controls>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Delete literacy content modal-->
  <div class="modal fade" id="deleteLiteracyModal" tabindex="-1" role="dialog" aria-labelledby="deleteLiteracyModal"
  aria-hidden="true">
   <div class="modal-dialog modal-dialog-centered" role="document">
     <div class="modal-content" *ngIf="singleLiteracyData">
       <div class="modal-header no-border">
         <h5 class="modal-title text-primary">Delete Content</h5>
         <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
           <span aria-hidden="true">&times;</span>
          </button>
       </div>
       <div class="modal-body">
         Are you sure you want to delete <span class="font-weight-bold">"{{singleLiteracyData.heading }}"</span> permanently?
       </div>
       <div class="modal-footer no-border">
         <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
         <button
           type="button"
           class="btn btn-danger"
           (click)="deleteContent(singleLiteracyData.id)"
         >
           <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
           </span>
           <span *ngIf="loading" class="mx-2">Loading...</span>
           <span *ngIf="!loading">
              Delete
           </span>
         </button>
       </div>
     </div>
   </div>
  </div>

  <!-- Add financial literacy content -->
  <div class="modal fade" id="addLiteracyContentModal" tabindex="-1" role="dialog" aria-labelledby="addLiteracyContentModal"
  aria-hidden="true" style="overflow: auto;">
    <div class="modal-dialog modal-lg" role="document" (click)="onClickOutside()">
      <div class="modal-content container-fluid">
        <div class="modal-header no-border">
          <h5 class="modal-title text text-primary" style="font-weight: bold;">Add Financial Literacy</h5>
          <button type="button" class="close close-btn"  aria-hidden="true" data-dismiss="modal" (click)="closeAddModal()">&times;</button>
        </div>
        <div class="modal-body">
          <form
            class="form"
            (ngSubmit)="addFinancialLiteracy()"
            id="addLiteracyForm"
            [formGroup]="addLiteracyForm"
          >
            <div class="form-group">
              <label for="heading">Heading</label>
              <input
                type="text"
                class="form-control"
                formControlName="heading"
              >
                <div
                  *ngIf="(addLiteracyForm.get('heading').dirty || addLiteracyForm.get('heading').touched)"
                  class="text-danger error_message"
                >
                  <span *ngIf="addLiteracyForm.get('heading').invalid && addLiteracyForm.get('heading').errors.required">
                    Please the heading is required
                  </span>
                </div>
            </div>

            <div class="form-group">
              <label for="image">Image</label>
              <div class="mult_images">
                <div formArrayName="photo_urls" *ngFor="let image of addLiteracyImages().controls; let i = index">
                  <div class="form-group" [formGroupName]="i">
                    <div class="card" style="width: 22rem;">
                      <div class="card-body">
                        <input
                          type="file"
                          class="form-control file-input"
                          (change)="changeFiles($event, i)"
                          accept="image/png, image/jpeg, image/jpg"
                        />
                        <br>
                        <input
                          type="number"
                          class="form-control"
                          formControlName="position"
                          placeholder="Position"
                        >
                        <br>
                        <div class="row">
                          <div class="col-md-3">
                            <button
                              type="button"
                              class="btn btn-info btn-sm"
                              (click)="removeAddImage(i)"
                            >Remove</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div (click)="addImage()" class="col">
                  <div class="card bg-light" id="add-card">
                    <div class="card-body text-center">
                      <i class="fas fa-plus"></i>
                      <p class="card-text">Add Image</p>
                    </div>
                  </div>
                </div>
                <div class="col">
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="sub-heading">Sub Heading</label>
              <input
                type="text"
                class="form-control"
                formControlName="sub_heading"
              >
            </div>
            <div class="form-group">
              <label for="position">Position on app</label>
              <input
                type="number"
                class="form-control"
                placeholder="Position content should appear on app"
                formControlName="position"
              />
              <div
                *ngIf="(addLiteracyForm.get('position').dirty ||
                addLiteracyForm.get('position').touched)"
                class="text-danger error_message"
              >
                <span *ngIf="addLiteracyForm.get('position').invalid &&
                addLiteracyForm.get('position').errors.required">
                  Please the position is required
                </span>
              </div>
            </div>

            <div>
              <label for="description">Description</label>
              <quill-editor
                [modules]="quillConfig"
                [styles]="editorStyle"
                formControlName="description"
              >
              </quill-editor>
            </div>
            <br>
            <div>
              <button
                type="submit"
                class="btn btn-primary float-right"
                [disabled]="!addLiteracyForm.valid"
              >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Save changes
              </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Edit financial literacy content -->
  <div class="modal fade" id="editLiteracyContentModal" tabindex="-1" role="dialog" aria-labelledby="editLiteracyContentModal"
  aria-hidden="true" style="overflow: auto;">
    <div class="modal-dialog modal-lg" role="document" (click)="onClickOutside()">
      <div class="modal-content container-fluid">
        <div class="modal-header no-border">
          <h5 class="modal-title text text-primary" style="font-weight: bold;">Edit Financial Literacy</h5>
          <button type="button" class="close close-btn"  aria-hidden="true" data-dismiss="modal" (click)="closeEditModal()">&times;</button>
        </div>
        <div class="modal-body">
          <form
            class="form"
            (ngSubmit)="editFinancialLiteracy()"
            id="updateLiteracyForm"
            [formGroup]="editLiteracyForm"
          >
            <div class="form-group">
              <label for="heading">Heading</label>
              <input
                type="text"
                class="form-control"
                formControlName="heading"
              >
                <div
                  *ngIf="(editLiteracyForm.get('heading').dirty || editLiteracyForm.get('heading').touched)"
                  class="text-danger error_message"
                >
                  <span *ngIf="editLiteracyForm.get('heading').invalid && editLiteracyForm.get('heading').errors.required">
                    Please the heading is required
                  </span>
                </div>
            </div>

            <div class="form-group">
              <label for="image">Image</label>
              <div class="mult_images">
                <div formArrayName="photo_urls" *ngFor="let image of editLiteracyImages().controls; let i = index">
                  <div class="form-group" [formGroupName]="i">
                    <div class="card" style="width: 22rem;">
                      <div *ngIf="image.value.image_url">
                        <img
                          class="card-img-top"
                          src='{{ "https://storage.googleapis.com/ezyagric-media" + image.value.image_url }}'
                          alt="image"
                          style="width: 22rem; height: 100px;"
                        >
                      </div>
                      <div class="card-body">
                        <input
                          type="file"
                          class="form-control file-input"
                          (change)="changeFiles($event, i)"
                          accept="image/png, image/jpeg, image/jpg"
                        />
                        <br>
                        <input
                          type="number"
                          class="form-control"
                          formControlName="position"
                          placeholder="Position"
                        >
                        <br>
                        <div class="row">
                          <div class="col-md-3">
                            <button
                              type="button"
                              class="btn btn-info btn-sm"
                              (click)="removeEditImage(i)"
                            >Remove</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div (click)="editImage()" class="col">
                  <div class="card bg-light" id="add-card">
                    <div class="card-body text-center">
                      <i class="fas fa-plus"></i>
                      <p class="card-text">Add Image</p>
                    </div>
                  </div>
                </div>
                <div class="col">
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="sub-heading">Sub Heading</label>
              <input
                type="text"
                class="form-control"
                formControlName="sub_heading"
              >
            </div>
            <div class="form-group">
              <label for="position">Position on app</label>
              <input
                type="number"
                class="form-control"
                placeholder="Position content should appear on app"
                formControlName="position"
              />
              <div
                *ngIf="(editLiteracyForm.get('position').dirty ||
                editLiteracyForm.get('position').touched)"
                class="text-danger error_message"
              >
                <span *ngIf="editLiteracyForm.get('position').invalid &&
                editLiteracyForm.get('position').errors.required">
                  Please the position is required
                </span>
              </div>
            </div>

            <div>
              <label for="description">Description</label>
              <quill-editor
                [modules]="quillConfig"
                formControlName="description"
                [styles]="editorStyle"
              >
              </quill-editor>
            </div>
            <br>
            <div>
              <button
                type="submit"
                class="btn btn-primary float-right"
                [disabled]="!editLiteracyForm.valid"
              >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Save changes
              </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Publish or unpublish content modal-->
  <div class="modal fade" id="publishContent" tabindex="-1" role="dialog" aria-labelledby="publishContent"
  aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
     <div class="modal-content" *ngIf="singleLiteracyData">
       <div class="modal-header no-border">
        <h5 class="modal-title text-primary">
          <span *ngIf="singleLiteracyData.status==='inactive'">Publish</span>
          <span *ngIf="singleLiteracyData.status==='active'">Unpublish</span>
          Content
        </h5>
         <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
           <span aria-hidden="true">&times;</span>
          </button>
       </div>
       <div class="modal-body">
        Are you sure you want to <span class="font-weight-bold" *ngIf="singleLiteracyData.status==='inactive'">publish</span>
        <span class="font-weight-bold" *ngIf="singleLiteracyData.status==='active'">unpublish</span> this content?
       </div>
       <div class="modal-footer no-border">
         <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
         <button
           type="button"
           class="btn btn-primary"
           (click)="publishContent(contentId)"
         >
           <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
           </span>
           <span *ngIf="loading" class="mx-2">Loading...</span>
           <span *ngIf="!loading">
             Yes
           </span>
         </button>
       </div>
     </div>
    </div>
  </div>
</div>
